import { render, staticRenderFns } from "./ErrorDashboardData.vue?vue&type=template&id=bfe16c40"
import script from "./ErrorDashboardData.vue?vue&type=script&lang=js"
export * from "./ErrorDashboardData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports